<template>
  <div class="row">
    <div v-if="notice" class="callout notice">settings updated</div>
    <h1 class="page-header text-center">springpay</h1>
    <div v-if="isProgramLoading" class="loading-container">
      <sb-loading-icon />
    </div>
    <div v-else class="medium-6 columns small-centered">
      <div class="sb-row bottom-spacing">
        <label for="merchant_cash_per_point_enabled">springpay enabled</label>
        <input
          type="checkbox"
          data-cy="cash-rewards-program-springpay-enabled-input"
          v-model="springpayEnabled"
          :disabled="!canEditSettings"
          name="merchant[cash_per_point_enabled]"
          id="merchant_cash_per_point_enabled"
        />
      </div>

      <div v-if="springpayEnabled" class="cash_per_point_enabled-wrapper">
        <label for="rewardPosString">POS discount ID (optional)</label>
        <input
          type="text"
          data-cy="cash-rewards-program-reward-pos-string-input"
          v-model="rewardPosString"
          :disabled="!canEditSettings"
          name="merchant[reward_pos_string]"
          id="merchant_reward_pos_string"
        />

        <div class="cash-conversion-wrapper">
          <label for="cashPerPoint">cash conversion</label>
          <div class="cash-conversion-field-wrapper">
            <div class="sb-icon cash-icon">
              <fai :icon="['fas', 'dollar-sign']" size="lg" />
            </div>
            <input
              type="number"
              min="0.01"
              max="1.00"
              step="0.01"
              data-cy="cash-rewards-program-cash-per-point-input"
              v-model="cashPerPoint"
              :disabled="!canEditSettings"
              name="merchant[cash_per_point]"
              id="merchant_reward_pos_string"
              @change="recalculatePointsNeeded"
            />
          </div>
        </div>
        <h6>points needed to earn a dollar: {{ pointsNeeded }}</h6>
      </div>
      <div class="sb-row center bottom-spacing">
        <button @click="clickedSubmit" :disabled="submitting" class="action-button button proceed">update</button>
      </div>
      <div class="sb-row center">
        <router-link :to="`/merchants/${this.merchantId}/${this.returnPage}_landing?editing=true`">update api token</router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import UserAbilitiesMixin from '../../mixins/UserAbilitiesMixin'
  import { currentMerchantAPI } from "../../services/api/currentMerchant"
  import { mapGetters } from 'vuex'

    export default {
      name: "CashRewardsProgram",
      data() {
        return {
          isProgramLoading: false,
          springpayEnabled: false,
          showSpringpay: false,
          cashPerPoint: 0.01,
          pointsNeeded: 100,
          notice: null,
          submitting: false,
        }
      },
      mixins: [UserAbilitiesMixin],
      computed: {
        merchantId() {
          return this.$route.params.id
        },
        canEditSettings() {
          return this.hasAccess(this.userAbilitiesValue, 'SETTINGS_EDIT')
        },
        returnPage() {
          return this.$route.query.type || 'springpay'
        },
        ...mapGetters(
          ['userAbilitiesValue']
        )
      },
      async created() {
        this.$store.dispatch('LOAD_CURRENT_USER')
        this.isProgramLoading = true
        try {
          const settings = await currentMerchantAPI.GETCashPerPointsSettings()

          this.showSpringpay = settings.show_springpay
          if (this.showSpringpay) {
            this.springpayEnabled = settings.springpay_enabled
            this.cashPerPoint = settings.dollars_per_point
            this.rewardPosString = settings.reward_pos_string
            this.isProgramLoading = false
            this.recalculatePointsNeeded()
          } else {
            this.$router.push(`/merchants/${this.merchantId}/program`)
          }

        } catch (error) {
          this.notice = "error, please refresh or contact support"
        }
      },
      methods: {
        async clickedSubmit() {
          const settings = {
            springpay_enabled: this.springpayEnabled,
            dollars_per_point: this.cashPerPoint,
            reward_pos_string: this.rewardPosString
          };

          this.submitting = true;
          try {
            const settingsResult = await currentMerchantAPI.PUTProgramSettings(this.merchantId, settings)
            this.submitting = false;
            this.notice = "Settings Saved";
          } catch (error) {
            this.notice = "There was an error saving your settings"
          }
        },
        recalculatePointsNeeded() {
          if (this.cashPerPoint == 0.0) {
            this.cashPerPoint = 0.01
            this.pointsNeeded = 100
          } else {
            this.pointsNeeded = (100 / (this.cashPerPoint * 100)).toFixed(2)
          }
        }
      }
    }
</script>
<style scoped>
.loading-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px
}
.cash-conversion-wrapper {
  display: flex;
  flex-direction: column;
}
.cash-conversion-field-wrapper {
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
}
.cash-icon {
  position: absolute;
  height: 2rem;
  width: 2rem;
  margin-bottom: 16px;
  left: -1.7rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
